"use client"

import React from 'react'
import { useTranslations } from 'next-intl'
import { UIInput, type UIInputProps } from './ui-input'
import { cn } from '../../lib/utils'

export interface UIInputDisabledProps extends Omit<UIInputProps, 'type' | 'placeholder' | 'disabled'> {
  type?: 'email' | 'text' | 'password'
  placeholder?: string
}

/**
 * UIInputDisabled - Disabled Input Block
 * 비활성화 상태의 입력 필드 컴포넌트입니다.
 * 비활성화 상태의 입력 필드입니다.
 */
export const UIInputDisabled = React.forwardRef<HTMLInputElement, UIInputDisabledProps>(
  ({
    type = "email",
    placeholder,
    className,
    ...props
  }, ref) => {
    const t = useTranslations('components.forms')

    return (
      <UIInput
        ref={ref}
        type={type}
        placeholder={placeholder || t('input.email.placeholder')}
        disabled={true}
        className={cn("max-w-xs", className)}
        {...props}
      />
    )
  }
)

UIInputDisabled.displayName = "UIInputDisabled"